import type { RelatedPerson } from 'fhir/r4';

import type { WithId } from '../types';
import { createReference } from './id';
import type { CreateReference } from './reference';

export const getRelatedPersonNameDisplay = (
  relatedPerson: RelatedPerson,
): string | undefined => {
  const names = relatedPerson.name;

  const name = names?.find((n) => n.text);

  return name?.text;
};

export const createRelatedPersonRefWithId = (
  relatedPerson: WithId<RelatedPerson>,
): CreateReference => {
  const name = getRelatedPersonNameDisplay(relatedPerson);

  const id = relatedPerson.id;

  const ref = createReference('RelatedPerson', id, name);

  return ref;
};
